import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const ContentPage = lazy(() => import('../pages/content/page'));
const CommercePage = lazy(() => import('../pages/commerce/page'));
const ProductDetailPage = lazy(() => import('../pages/commerce/product/[id]/page'));
const CommunityPage = lazy(() => import('../pages/community/page'));
const ChurchCommunityPage = lazy(() => import('../pages/community/church/[id]/page'));
const ChurchJoinPage = lazy(() => import('../pages/community/church/[id]/join/page'));
const TalentPage = lazy(() => import('../pages/talent/page'));
const TalentIntroPage = lazy(() => import('../pages/talent/intro/page'));
const MyPage = lazy(() => import('../pages/mypage/page'));
const MerchantPage = lazy(() => import('../pages/merchant/page'));
const MerchantLoginPage = lazy(() => import('../pages/merchant/login'));
const MerchantSignupPage = lazy(() => import('../pages/merchant/signup'));
const SupplierPage = lazy(() => import('../pages/supplier/page'));
const SupplierLoginPage = lazy(() => import('../pages/supplier/login'));
const SupplierSignupPage = lazy(() => import('../pages/supplier/signup'));
const ContentSupplierPage = lazy(() => import('../pages/content-supplier/page'));
const ContentSupplierLoginPage = lazy(() => import('../pages/content-supplier/login'));
const AdminLoginPage = lazy(() => import('../pages/admin/login'));
const AdminPage = lazy(() => import('../pages/admin/page'));
const ChurchAdminLoginPage = lazy(() => import('../pages/church-admin/login'));
const ChurchAdminPage = lazy(() => import('../pages/church-admin/page'));
const LoginPage = lazy(() => import('../pages/auth/login'));
const SignupPage = lazy(() => import('../pages/auth/signup'));
const EventsPage = lazy(() => import('../pages/events/page'));
const ContentExplorePage = lazy(() => import('../pages/content-explore/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/content',
    element: <ContentPage />,
  },
  {
    path: '/commerce',
    element: <CommercePage />,
  },
  {
    path: '/commerce/product/:id',
    element: <ProductDetailPage />,
  },
  {
    path: '/community',
    element: <CommunityPage />,
  },
  {
    path: '/community/church/:id',
    element: <ChurchCommunityPage />,
  },
  {
    path: '/community/church/:id/join',
    element: <ChurchJoinPage />,
  },
  {
    path: '/talent',
    element: <TalentPage />,
  },
  {
    path: '/talent/intro',
    element: <TalentIntroPage />,
  },
  {
    path: '/mypage',
    element: <MyPage />,
  },
  {
    path: '/merchant/login',
    element: <MerchantLoginPage />,
  },
  {
    path: '/merchant/signup',
    element: <MerchantSignupPage />,
  },
  {
    path: '/merchant',
    element: <MerchantPage />,
  },
  {
    path: '/supplier/login',
    element: <SupplierLoginPage />,
  },
  {
    path: '/supplier/signup',
    element: <SupplierSignupPage />,
  },
  {
    path: '/supplier',
    element: <SupplierPage />,
  },
  {
    path: '/content-supplier',
    element: <ContentSupplierPage />,
  },
  {
    path: '/content-supplier/login',
    element: <ContentSupplierLoginPage />,
  },
  {
    path: '/admin',
    element: <AdminLoginPage />,
  },
  {
    path: '/admin/dashboard',
    element: <AdminPage />,
  },
  {
    path: '/church-admin/login',
    element: <ChurchAdminLoginPage />,
  },
  {
    path: '/church-admin/dashboard',
    element: <ChurchAdminPage />,
  },
  {
    path: '/auth/login',
    element: <LoginPage />,
  },
  {
    path: '/auth/signup',
    element: <SignupPage />,
  },
  {
    path: '/events',
    element: <EventsPage />,
  },
  {
    path: '/content-explore',
    element: <ContentExplorePage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
